module.exports = __webpack_public_path__ + "static/img/微信图片_20240626143134.cf09542.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/微信图片_20240626143134.jpg
// module id = Bvdc
// module chunks = 1